import { useFlag, useFlagsStatus } from '@unleash/proxy-client-react';

/**
 * Navy Phase 0 shell (handoff "Layout"): with `navy-assessments` on, the app
 * shows only what Phase 0 built. The rail carries these pages, in this order,
 * and nothing else: no greyed items and no padlocks. A route that isn't one of
 * them falls back to Data Sources, which lands on Assessments. The header has
 * no notifications bell. App.js, Sidebar and AppHeader all read this hook, so
 * the rail, the routes and the header can never disagree.
 *
 * Until the flags arrive the shell can't know which it is, so the rail, the bell
 * and the pages the Navy shell hides wait for `useFlagsDecided` rather than
 * showing the platform's for a moment first. A failed fetch decides too.
 */
export const NAVY_PAGES = ['data-sources', 'library', 'activity-log', 'settings'];
export const NAVY_FALLBACK_PATH = '/data-sources';

export function useNavyShell() {
  return useFlag('navy-assessments');
}

export function useFlagsDecided() {
  const { flagsReady, flagsError } = useFlagsStatus();
  return flagsReady || flagsError;
}
